export default "__VITE_ASSET__DUBAscnF__"